import { decodeHexResponse } from '../_common/common.utils';
import BranchWiseFetchDetailsTypes from './BranchWiseFetchDetails.types';

const INITIAL_STATE = {
	branchWiseFetchResponse: null,
};

const branchWiseFetchDetailsReducer = (state = INITIAL_STATE, action: any) => {
	switch (action.type) {
		case BranchWiseFetchDetailsTypes.BRANCH_WISE_FETCH_START:
			return { ...state, branchWiseFetchResponse: null };
		case BranchWiseFetchDetailsTypes.BRANCH_WISE_FETCH_SUCCESS:
			return {
				...state,
				branchWiseFetchResponse: decodeHexResponse(
					action.payload,
					'fetchBranchWiseDataKey',
				),
			};
		case BranchWiseFetchDetailsTypes.BRANCH_WISE_FETCH_FAILURE:
			return {
				...state,
				branchWiseFetchResponse: decodeHexResponse(
					action.payload,
					'fetchBranchWiseDataKey',
				),
			};
		case BranchWiseFetchDetailsTypes.BRANCH_WISE_FETCH_RESPONSE_CHANGED:
			return { ...state, branchWiseFetchResponse: null };
		case BranchWiseFetchDetailsTypes.BRANCH_WISE_FETCH_RESPONSE_REST_START:
			return { ...state, branchWiseFetchResponse: null };
		default:
			return state;
	}
};

export default branchWiseFetchDetailsReducer;
